import * as Types from '../../api';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type OngoingMeetingsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type OngoingMeetingsQuery = { __typename?: 'Query', meetings?: { __typename?: 'MeetingList', items: Array<{ __typename?: 'Meeting', id: number, summary: string, startTime: any, length?: number | null } | null> } | null };

export type NextMeetingQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type NextMeetingQuery = { __typename?: 'Query', nextMeeting?: { __typename?: 'Meeting', id: number, summary: string, description?: string | null, startTime: any, invitations: Array<{ __typename?: 'Invitation', id: number, name?: string | null, email?: string | null, phoneNumber?: string | null }> } | null };


export const OngoingMeetingsDocument = gql`
    query OngoingMeetings {
  meetings(ongoing: true) {
    items {
      id
      summary
      startTime
      length
    }
  }
}
    `;

/**
 * __useOngoingMeetingsQuery__
 *
 * To run a query within a React component, call `useOngoingMeetingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOngoingMeetingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOngoingMeetingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useOngoingMeetingsQuery(baseOptions?: Apollo.QueryHookOptions<OngoingMeetingsQuery, OngoingMeetingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OngoingMeetingsQuery, OngoingMeetingsQueryVariables>(OngoingMeetingsDocument, options);
      }
export function useOngoingMeetingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OngoingMeetingsQuery, OngoingMeetingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OngoingMeetingsQuery, OngoingMeetingsQueryVariables>(OngoingMeetingsDocument, options);
        }
// @ts-ignore
export function useOngoingMeetingsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<OngoingMeetingsQuery, OngoingMeetingsQueryVariables>): Apollo.UseSuspenseQueryResult<OngoingMeetingsQuery, OngoingMeetingsQueryVariables>;
export function useOngoingMeetingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OngoingMeetingsQuery, OngoingMeetingsQueryVariables>): Apollo.UseSuspenseQueryResult<OngoingMeetingsQuery | undefined, OngoingMeetingsQueryVariables>;
export function useOngoingMeetingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OngoingMeetingsQuery, OngoingMeetingsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OngoingMeetingsQuery, OngoingMeetingsQueryVariables>(OngoingMeetingsDocument, options);
        }
export type OngoingMeetingsQueryHookResult = ReturnType<typeof useOngoingMeetingsQuery>;
export type OngoingMeetingsLazyQueryHookResult = ReturnType<typeof useOngoingMeetingsLazyQuery>;
export type OngoingMeetingsSuspenseQueryHookResult = ReturnType<typeof useOngoingMeetingsSuspenseQuery>;
export type OngoingMeetingsQueryResult = Apollo.QueryResult<OngoingMeetingsQuery, OngoingMeetingsQueryVariables>;
export const NextMeetingDocument = gql`
    query NextMeeting {
  nextMeeting {
    id
    summary
    description
    startTime
    invitations {
      id
      name
      email
      phoneNumber
    }
  }
}
    `;

/**
 * __useNextMeetingQuery__
 *
 * To run a query within a React component, call `useNextMeetingQuery` and pass it any options that fit your needs.
 * When your component renders, `useNextMeetingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNextMeetingQuery({
 *   variables: {
 *   },
 * });
 */
export function useNextMeetingQuery(baseOptions?: Apollo.QueryHookOptions<NextMeetingQuery, NextMeetingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NextMeetingQuery, NextMeetingQueryVariables>(NextMeetingDocument, options);
      }
export function useNextMeetingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NextMeetingQuery, NextMeetingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NextMeetingQuery, NextMeetingQueryVariables>(NextMeetingDocument, options);
        }
// @ts-ignore
export function useNextMeetingSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<NextMeetingQuery, NextMeetingQueryVariables>): Apollo.UseSuspenseQueryResult<NextMeetingQuery, NextMeetingQueryVariables>;
export function useNextMeetingSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<NextMeetingQuery, NextMeetingQueryVariables>): Apollo.UseSuspenseQueryResult<NextMeetingQuery | undefined, NextMeetingQueryVariables>;
export function useNextMeetingSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<NextMeetingQuery, NextMeetingQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<NextMeetingQuery, NextMeetingQueryVariables>(NextMeetingDocument, options);
        }
export type NextMeetingQueryHookResult = ReturnType<typeof useNextMeetingQuery>;
export type NextMeetingLazyQueryHookResult = ReturnType<typeof useNextMeetingLazyQuery>;
export type NextMeetingSuspenseQueryHookResult = ReturnType<typeof useNextMeetingSuspenseQuery>;
export type NextMeetingQueryResult = Apollo.QueryResult<NextMeetingQuery, NextMeetingQueryVariables>;